/* @flow */
/**
 * Provides sorting utilities for GAC reason use-case filter dropdown values.
 */
/**
 * Sorts array-based filter values by their leading numeric prefix while preserving
 * non-array values.
 */
const sortFilterData = (data: Object) => {
  const sortedData = {};
  Object.keys(data).forEach((key) => {
    if (Array.isArray(data[key])) {
      sortedData[key] = data[key].sort((a, b) => {
        // Filter labels begin with numeric codes that determine their display order.
        const numA = Number.parseInt((a.match(/^\d+/) || [])[0], 10);
        const numB = Number.parseInt((b.match(/^\d+/) || [])[0], 10);
        return numA - numB;
      });
    } else {
      sortedData[key] = data[key];
    }
  });
  return sortedData;
};
export default sortFilterData;
